
export default function urlEncodeManager(url, decode) {
  if (!url) return null;
  if (decode) return decodeURI(url);
  return encodeURI(url);
}



// WEBPACK FOOTER //
// ./src/services/general/urlEncodeManager.js